import { getTicketSeats, normalizeSeatSelections } from './seatConflictUtils';

/**
 * Bilet var ama seatSelections status!=1 olan koltuklara toplu status:1 yazar.
 * Cakisan koltuklarda ilk biletin user'i kullanilir (cakisma listede kalir).
 * @returns {{ next, filled, skipped, seats: string[] }}
 */
export function buildSoldSeatSelectionsFromTickets({
  tickets = [],
  seatSelections = null,
} = {}) {
  const next = { ...normalizeSeatSelections(seatSelections) };
  const now = String(Math.floor(Date.now() / 1000));
  const filled = [];
  const skipped = [];

  for (const ticket of tickets) {
    const uid =
      ticket?.user?.id ||
      (typeof ticket?.user === 'string' ? ticket.user : null) ||
      null;

    for (const seat of getTicketSeats(ticket)) {
      const seatId = seat?.id != null ? String(seat.id) : null;
      if (!seatId) continue;

      const cur = next[seatId];
      const status = cur && typeof cur === 'object' ? Number(cur.status) : null;
      if (status === 1) {
        skipped.push(seatId);
        continue;
      }

      next[seatId] = {
        status: 1,
        statusChangedAt: now,
        user: uid || cur?.user || null,
        ...(cur?.isBlockedSeat ? { isBlockedSeat: true } : {}),
      };
      filled.push(seatId);
    }
  }

  return {
    next,
    filled: [...new Set(filled)],
    skipped: [...new Set(skipped)],
    seats: [...new Set(filled)],
  };
}
